<template>
  <div id="preview" ref="preview">
    <v-layout
      row
      v-for="component in chosenNavs"
      :key="component.id"
    >
      <v-flex xs12 >
        <div
          v-if="showComponents"
          :is="componentTitle(component.title)" :key="component.id" :component="component"
          class="webdash-component"
          :style="[brandData.colors, brandData.fonts, brandData.borderRadius]"
          :images="brandData.images"
        ></div>
      </v-flex>
    </v-layout>
    <v-layout
      row
      v-for="component in chosenBodies"
      :key="component.id"
    >
      <v-flex xs12 >
        <div
          v-if="showComponents"
          :is="componentTitle(component.title)" :key="component.id" :component="component"
          class="webdash-component"
          :style="[brandData.colors, brandData.fonts, brandData.borderRadius]"
          :images="brandData.images"
        ></div>
      </v-flex>
    </v-layout>
    <v-layout
      row
      v-for="component in chosenFeet"
      :key="component.id"
    >
      <v-flex xs12 >
        <div
          v-if="showComponents"
          :is="componentTitle(component.title)" :key="component.id" :component="component"
          class="webdash-component"
          :style="[brandData.colors, brandData.fonts, brandData.borderRadius]"
          :images="brandData.images"
        ></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Navigation from '../components/Navigation.vue';
import webdashComponents from "../webdash_components";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      navComponents: this.$store.state.navComponents,
      bodyComponents: this.$store.state.bodyComponents,
      footerComponents: this.$store.state.footerComponents,
      showComponents: false,
    }
  },
  created() {
    this.showComponents = true;
    this.$store.commit("chooseBrand", this.$route.query.brand);
  },
  mounted () {
    window.scrollTo(0, 0);
    document.getElementById('app').scrollIntoView();
    this.chosenBrand = this.brand;
    let headings = $('.webdash-component').find(":header")
    let links = $('.webdash-component').find("a, button, .form-control, .btn, input")
    if (this.brand === 'chevrolet' || this.brand === 'hyundai' || this.brand === 'mazda') {
      headings.css({ textTransform:'uppercase'});
    }
    if (this.brand === 'mazda') {
      headings.css({ textTransform:'uppercase', letterSpacing:'1px'});
      links.css({ textTransform:'uppercase', fontSize:'13px', letterSpacing:'2px', borderRadius:'3px'});
    }
  },
  beforeDestroy() {
    this.showComponents = false;
    this.$store.commit("chooseBrand", "None");
  },
  computed: {
    ...mapGetters(["brandData"]),
    brand() {
      return this.$route.query.brand;
    },
    componentParams() {
      var called = this.$route.query.comps.split('-');
      return called;
    },
    chosenNavs() {
      return this.previewComponents(this.navComponents, this.componentParams)
    },
    chosenBodies() {
      return this.previewComponents(this.bodyComponents, this.componentParams)
    },
    chosenFeet() {
      return this.previewComponents(this.footerComponents, this.componentParams)
    }
  },
  methods: {
    getParams() {
      console.log(this.componentParams);
    },
    componentTitle(title) {
      return title.toLowerCase().replaceAll(" ", "-");
    },
    previewComponents(items, params) {
      var previews = [];
      for (var p = 0; p < params.length; p++) {
        items.filter((item) => {
          if (params[p].toString() === item.id.toString()) {
            previews.push(item);
          }
        });
      }
      return previews;
    }
  },
  components:
    webdashComponents
}
</script>

<style scoped>
#preview {
  background: #fff;
  position: relative;
  z-index: 0;
}
</style>

<style>
#preview .navbar-nav a, #preview .contact-toolbar-dark-component a {
  letter-spacing: 0px !important;
  border-radius: 0 !important;
}
#preview .webdash-component, #preview .webdash-footer {
  font-family: var(--body-text);
}
#preview .webdash-component h1, #preview .webdash-component h2,
#preview .webdash-footer h1, #preview .webdash-footer h2 {
  font-family: var(--heading-text);
}
#preview .webdash-component h3, #preview .webdash-footer h3, #preview .webdash-component h4, #preview .webdash-footer h4, #preview .webdash-component h5, #preview .webdash-footer h3, #preview .webdash-component h6, #preview .webdash-footer h6 {
  font-family: var(--subheading-text);
}
#preview .webdash-component .strong {
  font-family: var(--bold-text);
}
</style>